// extracted by mini-css-extract-plugin
export default {"progressBar":"styles_progressBar__lFI6s","value":"styles_value__22RKr","bar":"styles_bar__IxQpy"};